export enum UserGettersEnum {
    GET_USER_PROFILE = 'getUserProfile',
    GET_USER_ROLES = 'getUserRoles',
    GET_API_TOKEN = 'getApiToken',
    GET_USERS_ME_TOKEN = 'getUsersMeToken',
    GET_ADMIN_STATUS = 'getAdminStatus',
    GET_USER_STATUS = 'getUserStatus',
    GET_USER_TOKEN_DATA = 'getUserTokenData'
}
